export default { 
   comissaoErrors () {
     const errors = []
     if (!this.$v.item.value.$dirty) return errors
     !this.$v.item.value.required && errors.push('Comissão é obrigatório.')
     !this.$v.item.value.maxValue && errors.push('Valor máximo é 30,00.')
     return errors
   },
 }